// 企业全景
import React from 'react';

import Widget from '../widget/Widget';
import Registration from './entityPanorama/Registration';
import EntityInvest from './entityPanorama/EntityInvest';
import Ckjz from './entityPanorama/ckjz';
import Nsdj from './entityPanorama/nsdj';
import AnnualReports from './entityPanorama/AnnualReports';
import NetworkManage from './entityPanorama/NetworkManage';
import QualificationHonor from './entityPanorama/QualificationHonor';
import IntellectualProperty from './entityPanorama/IntellectualProperty';
import IllegalWarning from './entityPanorama/IllegalWarning';
import DemandTalents from './entityPanorama/DemandTalents';
import DealInfo from './entityPanorama/DealInfo';

import '../css/panorama.css'
import "../css/EntityPanorama.css"

class EntityPanorama extends React.Component
{
    constructor( props )
    {
        super( props )

        this.state = {
            contentType : "ckjz",
            entname : this.props.ENTNAME,
            curIndex: 0, // 高亮下标
            headerTop: null, // header到顶部的距离
            headerHeight: null, // header的高度
            consTops: [], // 内容每一项到顶部的距离
            navList: [
              {
                id: 'registration',
                text: '基本信息'
              },
              {
                id: 'entityInvest',
                text: '企业投资'
              },
              {
                id: 'annualReports',
                text: '企业年报'
              },
              {
                id: 'dealInfo',
                text: '交易信息'
              },
              {
                id: 'qualificationHonor',
                text: '资质荣誉'
              },
              {
                id: 'intellectualProperty',
                text: '知识产权'
              },
              {
                id: 'illegalWarning',
                text: '违法警示'
              },
              {
                id: 'demandTalents',
                text: '人才需求'
              }
            ]
        }

        Widget.addSessionStorage("entname",  this.props.ENTNAME); 

        this.change = this.change.bind(this);
    }

    componentWillReceiveProps( nextProps )
    {
        let { entname } = this.state;

        if( entname!==nextProps.ENTNAME )
        {
            Widget.addSessionStorage("entname", nextProps.ENTNAME);

            this.state["entname"] = nextProps.ENTNAME;

            this.setState({contentType: "registration", entname:nextProps.ENTNAME});
        }
    }

    change(value, obj )
    {
        for( let i=0; i<obj.target.parentNode.childNodes.length; i++ )
        {
            obj.target.parentNode.childNodes[i].className = "title-label";
        }

        obj.target.className = 'title-label title-label-active';
        this.setState({contentType:value});

    }

    componentDidUpdate()
    {
        let headerTopNew = this.header.offsetTop;
        let headerHeightNew =  this.header.clientHeight;
        // let consTopsNew = [...this.main.children].map(item => item.offsetTop);

        const { headerTop } = this.state;

        if( headerTop!==headerTopNew  )
        {
            let curIndex = this.state.curIndex;

            this.setState({
                headerTop:headerTopNew,  
                headerHeight:headerHeightNew,
                curIndex
                
            });
            
            // consTops:consTopsNew

            // this.state.consTops.forEach((top, index) => 
            // {
            //     if ( this.props.scrollTop >= top-this.state.headerHeigh) 
            //     {
            //         curIndex = index;
            //     }
            // })

        }
        
        
    }

    setScrollTop(value){
        this.props.setScrollTop(value)
    }

    render()
    {
        const { contentType,headerTop,navList,curIndex} = this.state;

        return (
            <div className="page entity-panorama"  ref={el => this.header = el}>
                {/* <div className="page-weidu entity-title space-between"  ref={el => this.main = el}  style={scrollTop >= headerTop&&headerTop!==null?{position:'fixed',top:this.props.headersHeight+this.props.tabHeight,width:"938px",zIndex:"100",padding:"5px 20px",height:"43px"}:{position:null}}> */}
                {/* <div className="page-weidu entity-title space-between"  style={this.props.headersHeight>0?{width:"938px",position:"fixed",background:"#ffffff",zIndex:"100",marginTop:"6px",borderTop:"1px solid",borderRadius:"0"}:{position:"none"}}>
                    <div id="registration" className="title-label " onClick={this.change.bind(this, "registration")}>基本信息</div>
                    <div id="entityInvest" className="title-label " onClick={this.change.bind(this, "entityInvest")}>企业投资</div>
                    <div id="annualReports" className="title-label " onClick={this.change.bind(this, "annualReports")}>企业年报</div>
                    <div id="networkManage" className="title-label " onClick={this.change.bind(this, "networkManage")}>网络经营</div>
                    <div id="dealInfo" className="title-label " onClick={this.change.bind(this, "dealInfo")}>交易信息</div>
                    <div id="qualificationHonor" className="title-label " onClick={this.change.bind(this, "qualificationHonor")}>资质荣誉</div>
                    <div id="intellectualProperty" className="title-label " onClick={this.change.bind(this, "intellectualProperty")}>知识产权</div>
                    <div id="illegalWarning" className="title-label " onClick={this.change.bind(this, "illegalWarning")}>违法警示</div>
                    <div id="demandTalents" className="title-label " onClick={this.change.bind(this, "demandTalents")}>人才需求</div>

                    {navList.map((item, index) => (
                        <div
                          id={item.id}
                          className={['title-label', curIndex === index ? 'title-label title-label-active' : ''].join('')}
                          onClick={this.changeTab.bind(this, item.id, index)}
                        >{item.text}</div>
                      ))}
                </div> */}
                {/* <div style={this.props.headersHeight>0?{height:"56px",display:"block"}:{display:"none"}}></div> */}
                <div>
                    <EntityPanoramaItem contentType={contentType}/>
                </div>
            </div>
        )
    }
}

export default EntityPanorama

export const EntityPanoramaItem = ({ contentType }) => 
{
    if( contentType==="registration" )
    {
        return <Registration setScrollTop={top => this.setScrollTop(top)}/>
    }
    else if( contentType==="entityInvest" )
    {
        return <EntityInvest />
    }
    else if( contentType==="annualReports" )
    {
        return <AnnualReports />
    }
    else if( contentType==="networkManage" )
    {
        return <NetworkManage />
    }
    else if( contentType==="dealInfo" )
    {
        return <DealInfo />
    }
    else if( contentType==="qualificationHonor" )
    {
        return <QualificationHonor />
    }
    else if( contentType==="intellectualProperty" )
    {
        return <IntellectualProperty />
    }
    else if( contentType==="illegalWarning" )
    {
        return <IllegalWarning />
    }
    else if( contentType==="demandTalents" )
    {
        return <DemandTalents />
    }
    else 
    {
        return <Registration />
    }
}
